
<template>
    <div>
        <div class="col-lg-8" v-if="records && records.length > 0 && ! searchKey">
            <small class="font-weight-bold">
                Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                {{ pagination.total }} entries
            </small>
        </div>

        <div
            class="card shadow"
            v-if="records && records.length > 0"
        >
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th width="15%">Batch Name <br>/ Code</th>
                        <th width="10%">Active Status</th>
                        <th width="10%">Commencement <br> Date</th>
                        <th width="10%">Expiry <br> Date</th>
                        <th width="10%">Date Created <br> / Status</th>
                        <th width="10%">&nbsp;</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            {{ row.name }}<br>
                            <badge
                                size="sm" type="success"
                                class="font-weight-bolder"
                            >
                                {{ row.code }}
                            </badge>&nbsp;
                            <badge
                                size="sm" type="primary"
                                class="font-weight-bolder"
                            >
                                {{ row.year }}
                            </badge>
                        </td>
                        <td>
                            <badge
                                :type="((row.status == 'enable') ? 'success' : 'danger')"
                                class="font-weight-bolder" size="sm"
                            >
                                {{ row.status }}
                            </badge>
                        </td>
                        <td class="text-capitalize">
                            {{ row.commencement_date | formatDate }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.expiry_date | formatDate }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.created_at | formatDate }} <br>
                            <badge
                                :type="((getExactStatus(row) == 'open') ? 'success' : 'danger')"
                                class="font-weight-bolder" size="sm"
                            >
                                {{ getExactStatus(row) }}
                            </badge>
                        </td>
                        <td>
                            <button
                                class="btn btn-sm btn-info"
                                @click="$emit('editBatch', row)"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-pen"></i>
                                Edit
                            </button>

                            <button
                                :class="'btn btn-sm btn-'+ (row.status == 'enable' ? 'warning' : 'success')"
                                @click="changeStatus(row.id)"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                            >
                                <i class="fa fa-history"></i>
                                {{ (row.status == 'enable' ? 'Deactivate' : 'Activate') }}
                            </button> <br>

                            <router-link
                                :to="'/remediation/applications-'+ row.id"
                                class="btn btn-sm btn-primary marginTop5"
                            >
                                <i class="fa fa-eye"></i>
                                Applications
                            </router-link>

                            <button
                                class="btn btn-sm btn-dark"
                                @click="exportBatch(row.id, index)"
                                :disabled="(privileges && privileges.update == 'no') || ! privileges"
                                v-if="row.application_count > 0"
                            >
                                <i class="fa fa-file-export"></i>
                                {{isLoading && (isIndex == index) ? 'Loading...' : 'Export'}}
                            </button>

                            <button
                                class="btn btn-sm btn-danger"
                                @click="removeBatch(row.id)"
                                :disabled="(privileges && privileges.delete == 'no') || ! privileges"
                                v-if="row.application_count < 0"
                            >
                                <i class="fa fa-ban"></i>
                                Remove
                            </button>
                        </td>
                    </template>
                </base-table>
            </div>

            <div
                class="card-footer d-flex justify-content-end bg-transparent"
                v-if="hasPagination"
                    @click="paginate"
            >
                <base-pagination
                    :total="pagination.total"
                    align="center"
                    v-model="pagination.number"
                    :perPage="pagination.perPage"

                >
                </base-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    import swal from 'sweetalert2';// import sweet alert
    import { mapActions, mapGetters } from 'vuex';
    import axios from 'axios';
    import FileSaver from 'file-saver';

    export default {
        name: 'RemediationBatchData',
        props: ['records', 'hasPagination', 'pagination', 'paginate', 'privileges', 'searchKey', 'loadRemediationBatches'],
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            },
            formatPrice(value) {
                if(value) {
                    let val = (value/1).toFixed(2).replace(',', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ ' NGN';
                } else {
                    return 'N/A';
                }                
            }
        },
        data() {
            return {
                isLoading: false,
                isIndex: null
            }
        },
        computed:  {
            ...mapGetters(['getExportRemedationListUrl', 'getAuthorizationToken', 'user'])
        },
        methods: {
            ...mapActions(['addRemediationBatch', 'downloadAssessmentFiles']),
            getExactStatus(data) {// get exact status of batch 
                let startDate   = moment(data.commencement_date);// get commencement date minus one day
                let endDate     = moment(data.expiry_date).add(1, 'days');// get expiry date plus one day
                return (moment().isBetween(startDate, endDate)) ? 'open' : 'closed'; 
            },
            changeStatus(id) {
                let data = { 'id' : id, 'admin_id' : this.$store.state.user.userId, option: 'change' };
                this.preloader(); // show loading
                this.addRemediationBatch(data).then((res) => {// delete country
                    if(res.status) {
                        this.loadRemediationBatches();// refresh page
                        swal.fire("Status Changed", res.msg, "success");
                    } else {
                        this.loadRemediationBatches();// refresh page
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(err => {
                    this.loadRemediationBatches();// refresh page
                    swal.fire(err.message+"!", "An error occurred while updating, try again", "warning");
                });
            },
            removeBatch(id) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        this.makeRemoveApiCall(id);// make api call
                    }
                });
            },
            makeRemoveApiCall(id) {
                let data = { 'id' : id, 'admin_id' : this.$store.state.user.userId, option: 'delete' };
                this.preloader(); // show loading
                this.addRemediationBatch(data).then((res) => {// delete country
                    if(res.status) {
                        this.loadRemediationBatches();// refresh page
                        swal.fire("Batch Deleted", res.msg, "success");
                    } else {
                        this.loadRemediationBatches();// refresh page
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(err => {
                    this.loadRemediationBatches();// refresh page
                    swal.fire(err.message+"!", "An error occurred while deleting, try again", "warning");
                });
            },
            exportBatch(id, index) {// export batch applications
                this.preloader();
                this.isLoading = true;
                this.isIndex = index;
                const data = {  
                    id: id,
                    admin_id: this.user.id, 
                    url : this.getExportRemedationListUrl,
                    contentType : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    fileName :  'remediation-list.xlsx',
                    msg : 'Failed to export Remediation List sheet:'
                };
                return this.downloadAssessmentFiles(data).then((res) => {// download file
                    this.isLoading = res; // stop loading
                    this.isIndex = null;
                    swal.close();
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
    .marginTop5 {
        margin-top: 5px;
    }
</style>
